import config from '@/common/config';
import { CreateSessionDataParams, createABISessionDatum } from '@biconomy/account';

export function createJoinTableSessionParams(sessionKeyAddress: `0x${string}`): CreateSessionDataParams[] {
  const usdtApproveTablesSessionLeaf = createABISessionDatum({
    interval: {
      validAfter: 0,
      validUntil: 0,
    },
    sessionKeyAddress,
    contractAddress: config.contracts.usdt,
    functionSelector: 'approve(address,uint256)',
    rules: [
      {
        offset: 0,
        condition: 0,
        referenceValue: config.contracts.tables,
      },
    ],
    valueLimit: 0n,
  });
  const tablesJoinSessionLeaf = createABISessionDatum({
    interval: {
      validAfter: 0,
      validUntil: 0,
    },
    sessionKeyAddress,
    contractAddress: config.contracts.tables,
    functionSelector: 'joinTable(uint256,uint256)',
    rules: [],
    valueLimit: 0n,
  });

  return [usdtApproveTablesSessionLeaf, tablesJoinSessionLeaf];
}
